module.exports = __webpack_public_path__ + "SOMMET_PRIMARY_CHARCOAL.png?033565826c978d6f82c6e1108e04a510";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/SOMMET_PRIMARY_CHARCOAL.png
// module id = 103
// module chunks = 0